import Chip from '@mui/material/Chip'
import { useCallback } from 'react'

interface Props {
	supplier: {
		id: string
		name: string
	}
	onDelete: (id: string) => void
}

const SupplierFilterChip = ({ onDelete, supplier: { id, name } }: Props) => {
	const handleDelete = useCallback(() => onDelete(id), [id, onDelete])
	return <Chip onDelete={handleDelete} label={name} />
}

export { SupplierFilterChip }
